module.exports = __webpack_public_path__ + "fonts/motiva-sans-thin-italic.ce697d7.otf";